import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { offeringConfig } from "../offering_config";
import { TemplateOfferingDetailsMeetingRoom } from "../template_offering_details_meeting_room";
import { Text } from "../text";
import { TextLink } from "../text_link";
import { partnerConfig } from "./nomadworks_partner_config";
import { useNomadworksAnalytics } from "./nomadworks_analytics";
import { testimonials } from "./nomadworks_data";

const Theme = lazyWithRetry(() => import("./nomadworks_theme"));

const faqs = [
  {
    question:
      "How do I access the conference room once arriving at the location?",
    answer:
      "Once you arrive at the building, please check-in with the front desk.",
  },
  {
    question: "How do I modify or cancel a booking?",
    answer:
      "You may cancel or modify the date of your reservation 24 hours before your booking begins. In order to change your reservation, please reach out to the front-desk or reply to the confirmation email 24 hours before the reservation begins.",
  },
  {
    question: "How many people can I invite to the meeting?",
    answer: "You can invite as many guests as per the capacity of the room.",
  },
  {
    question: "Am I allowed to bring food into the conference room?",
    answer:
      "Cold refreshments and hot drinks are allowed in the room. Please be sure to leave the room clean once your reservation ends.",
  },
  {
    question: "Can I send food/equipment delivery before the meeting?",
    answer:
      "Only the host and its guests are allowed to bring in items to the conference room. The on-site staff cannot accept any type of delivery.",
  },
  {
    question:
      "How can I extend my meeting once I have already started my reservation?",
    answer: (
      <Text>
        <TextLink
          href={`/offerings/${offeringConfig.Nomadworks.slugConfig.meetingRoom}`}
        >
          Use the website
        </TextLink>{" "}
        to book the additional time you need for your meeting room. Also, feel
        free to reach out to the front-desk for further assistance.
      </Text>
    ),
  },
  {
    question: "Can I use the printer?",
    answer:
      "If you have something urgent that needs printing, please approach the front desk and we will assist you.",
  },
  {
    question: "Can I stay for the rest of the day after my meeting?",
    answer:
      "Yes, you may stay at the common area or lounges if there’s space available. The discounted rate is $20 for the rest of the day following meeting room booking.",
  },
];

export function OfferingNomadworksMeetingRoom() {
  useNomadworksAnalytics();

  return (
    <Fragment>
      <Theme />
      <TemplateOfferingDetailsMeetingRoom
        showAddress
        showDirections
        partnerConfig={partnerConfig}
        data={{
          testimonials,
          faqs,
          generalInfo: {
            title: `Health & safety`,
            description: `We're working hard and have taken extra steps to ensure all our members and their guests are safe and socially distanced at work.`,
            bulletPoints: [
              { text: "Increased cleaning" },
              { text: "Masks provided if you need one." },
              { text: "New tech air filteration system." },
              {
                text: "Dedicated entrance & exit staircases for social distancing.",
              },
            ],
          },
        }}
      />
    </Fragment>
  );
}
